export default __webpack_public_path__ + "static/media/YOGABOT-ADVISOR.4113eaa4.png";